import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

const NotFoundContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const NotFound = () => {
  return (
    <NotFoundContainer>
      <h1>Certificate Not Found</h1>
      <p>We couldn't find the certificate you are looking for.</p>
    </NotFoundContainer>
  );
};

export default NotFound;
